module.exports = __webpack_public_path__ + "img/section-3-photo.6da8b1e3.png";